import React from 'react'
import { withIcon } from '../../withIcon'

interface UserFollowIconProps {
  size?: string
  color?: string
}

function UserFollowIcon (props: UserFollowIconProps) {
  const {
    size = '16px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <g transform="translate(0, 2)">
        <path d="M10.0788 10.75C10.0788 9.97469 10.0788 9.58703 9.98644 9.27159C9.77851 8.56136 9.24211 8.00558 8.55667 7.79013C8.25223 7.69444 7.87809 7.69444 7.12983 7.69444H4.44896C3.70069 7.69444 3.32656 7.69444 3.02212 7.79013C2.33668 8.00558 1.80028 8.56136 1.59235 9.27159C1.5 9.58703 1.5 9.97469 1.5 10.75M8.20218 3.25C8.20218 4.63071 7.12194 5.75 5.78939 5.75C4.45685 5.75 3.37661 4.63071 3.37661 3.25C3.37661 1.86929 4.45685 0.75 5.78939 0.75C7.12194 0.75 8.20218 1.86929 8.20218 3.25Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <line x1="12.5" y1="5" x2="12.5" y2="10" stroke={color} strokeLinecap="round" />
      <line x1="15" y1="7.5" x2="10" y2="7.5" stroke={color} strokeLinecap="round" />
    </svg>
  )
}

export default withIcon(UserFollowIcon)
